import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
  withStyles,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const styles = {
  message: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px 0 24px',
  },
  actions: {
    paddingRight: '16px',
  },
  title: {
    wordBreak: 'break-word',
  }
};

class ServiceAnnouncementDialog extends React.Component {

  static propTypes = {
    announcements: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,

    classes: PropTypes.object.isRequired,
  }

  state = {
    selectedIndex: 0,
  }

  handlePrevious = () => {
    if (this.state.selectedIndex > 0) {
      this.setState({selectedIndex: this.state.selectedIndex - 1});
    }
  }

  handleNext = () => {
    if (this.state.selectedIndex < (this.props.announcements.length - 1)) {
      this.setState({selectedIndex: this.state.selectedIndex + 1});
    }
  }

  render() {
    const {announcements, open, handleClose, classes} = this.props;
    const announcement = announcements[this.state.selectedIndex];
    const numAnnouncements = announcements.length;
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        {numAnnouncements > 1 ?
          <div className={classes.header}>
            <Typography className={classes.numAnnouncements} variant="subtitle2">
              Announcement {`${this.state.selectedIndex + 1} / ${numAnnouncements}`}
            </Typography>
            <div>
              <IconButton
                data-id="previous-announcement"
                onClick={this.handlePrevious}
                disabled={this.state.selectedIndex === 0}
              >
                <ArrowBackIcon />
              </IconButton>
              <IconButton
                data-id="next-announcement"
                onClick={this.handleNext}
                disabled={this.state.selectedIndex === numAnnouncements - 1}
              >
                <ArrowForwardIcon />
              </IconButton>
            </div>
          </div>
          : null
        }
        <DialogTitle className={classes.title}>{announcement.title}</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.message}>
            {announcement.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(ServiceAnnouncementDialog);



// WEBPACK FOOTER //
// ./src/ondemand/components/ServiceAnnouncementsAlert/ServiceAnnouncementDialog.js